var React = require('react');

function Teeth (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5636 5.01637C11.0397 6.73237 10.3412 11.25 8.52513 11.25C7.16306 11.25 7.33769 8.83359 6.42964 8.83359C5.5216 8.83359 5.69622 11.25 4.47386 11.25C3.91506 11.25 3.28641 10.4445 2.58792 8.65849C2.02912 7.04755 1.4354 5.36657 1.26077 3.6856C1.05123 0.778904 3.94998 0.0784962 5.45175 1.37425C5.45175 1.37425 6.04547 1.89956 6.46457 1.89956C7.02336 1.89956 7.30276 1.58437 7.58216 1.37425C10.0967 -0.44681 12.4367 2.00462 11.5636 5.01637Z","stroke":"#333333","strokeWidth":"1.05"}));
}

Teeth.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = Teeth;

Teeth.default = Teeth;
